import { ReactNode, forwardRef } from "react";
import { Stack, TextField as TextFieldMui, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ILabelProps } from "components/TextField/types";

const Label = styled(`label`)<ILabelProps>(({ disabled, theme, direction }) => ({
  ...(direction === "column"
    ? {
        ...theme.typography.body2,
      }
    : {
        ...theme.typography.subtitle1,
        minWidth: 110,
        maxWidth: 160,
      }),
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
}));

type FormLabelProps = {
  children: ReactNode;
  disabled?: boolean;
  label: ReactNode;
  fullWidth?: boolean;
  direction?: "column" | "row";
  id?: string;
};

const FormLabel = forwardRef<any, FormLabelProps>(
  ({ disabled, label, fullWidth, direction = "column", children, ...props }, ref) => {
    return (
      <Stack
        direction={{ xs: "column", sm: direction }}
        sx={{ ...(fullWidth && { width: "100%" }) }}
        {...(direction === "row" && {
          spacing: 1,
          alignItems: { xs: "start", sm: "start" },
        })}
      >
        {label && (
          <Label direction={direction} disabled={disabled} htmlFor={props?.id} ref={ref} {...props}>
            {label}
          </Label>
        )}
        {children}
      </Stack>
    );
  }
);

export default FormLabel;
